import React from 'react'
import {Link} from 'react-router-dom'

import prdimg1 from '../../images/icono_1.png'
import prdimg2 from '../../images/icono_2.png'
import prdimg3 from '../../images/icono_3.png'


const Features = (props) => {
    const ClickHandler = () =>{
        window.scrollTo(10, 0);
     }


     const featres = [
         {
            fIcon:prdimg1,
            title:'Desarrollo de Software a la Medida',
            des:'Desarrollamos aplicaciones y plataformas personalizadas para optimizar los procesos clave de su negocio, enfocándonos en funcionalidad, escalabilidad y experiencia del usuario.', 
         },
         {
            fIcon:prdimg2,
            title:'Automatización de Procesos Empresariales',
            des:'Ofrecemos consultoría para identificar oportunidades de automatización que optimicen costos, mejoren eficiencia y aumenten productividad, implementando soluciones tecnológicas a medida.', 
         },
         {
            fIcon:prdimg3,
            title:'Capacitación en Herramientas TIC',
            des:'Ofrecemos programas de formación para mejorar las habilidades tecnológicas de su equipo, ayudándoles a aprovechar al máximo las herramientas y plataformas digitales en su entorno laboral.'      
         },
         
     ]


    return(
        <section className={`wpo-features-section section-padding  ${props.featuresClass}`}>
            <div className="container">
                <div className="row">
                    {featres.map((featres, fitem) => (
                        <div className="col-lg-4 col-md-6 col-12" key={fitem}>
                            <div className="wpo-features-item">
                                <div className="wpo-features-icon">
                                    <div className="icon">
                                        <img src={featres.fIcon} alt=""/>
                                    </div>
                                </div>
                                <div className="wpo-features-text">
                                    <h2>{featres.title}</h2>
                                    <p>{featres.des}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default Features;